import { Box, Button, Grid, TextField, Typography } from "@mui/material";
import { styled } from "@mui/system";

export const OrdersOrderNameContainer = styled("div")(() => ({
  display: "flex",
  alignItems: "flex-end",
  gap: "0.5rem",
  marginBottom: "1rem",
  backgroundColor: "transparent",
  "&:hover": { backgroundColor: "transparent" },
  color: "currentcolor",
  border: "none",
  cursor: "pointer",
  width: "auto",
  textTransform: "none",
}));

export const OrdersHeaderButton = styled(Button)(() => ({
  fontSize: "14px",
  textTransform: "none",
  padding: "0px 8px",
  color: "#00000085",
  minWidth: "118px",
}));

export const OrdersHeaderTextField = styled(TextField)(() => ({
  height: "36px",
  justifyContent: "flex-end",
  marginTop: 0,
  ".MuiInput-input": {
    fontSize: "32px",
    fontWeight: 600,
    padding: 0,
  },
}));

export const OrdersHeaderTitle = styled(Typography)(() => ({
  fontSize: "32px",
  fontWeight: 600,
  lineHeight: 1,
  overflowWrap: "anywhere",
}));

export const OrdersFormBasicContainer = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  backgroundColor: "#fff",
  padding: "1rem",
  marginBottom: "24px",
  borderRadius: "10px",
  height: "auto",
}));

export const OrderFormShortRowGridItem = styled(Grid, {
  shouldForwardProp: (prop) => prop !== "width",
})<{ width?: string }>(({ width }) => ({
  width: `${width}!important`,
  minWidth: `${width}!important`,
  maxWidth: `${width}!important`,
  flexDirection: "column",
  alignItems: "flex-start",
}));

export const OrderFormShortRowBundlingContainer = styled(Box)(() => ({
  backgroundColor: "rgba(74, 29, 156, 0.08)",
  padding: "8px 0px 8px 8px",
  borderRadius: "4px",
  maxWidth: "1700px",
  fontSize: "14px",
}));

export const OrderFormShortRowBundlingHeader = styled(Typography)(() => ({
  padding: "0 12px 0 8px",
  textTransform: "uppercase",
  fontWeight: 700,
  color: "#7A4CC3",
  lineHeight: "120%",
}));

export const OrderFormShortCard = styled(Box)(() => ({
  backgroundColor: "#fff",
  padding: "16px 8px 16px 16px",
  marginBottom: "24px",
  borderRadius: "10px",
}));

export const OrderRowCounterContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== "size",
})(({ size }: { size: number }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  height: `${size}px`,
  width: `${size}px`,
  borderRadius: "100%",
  background:
    "conic-gradient(from 0deg at 50% 50%, #CECECE 0deg, #F5F5F5 360deg)",
}));

export const FormTitleGrid = styled(Grid)(() => ({
  justifyContent: "flex-end",
  alignItems: "center",
}));

export const FormTitleGridRows = styled(Grid)(() => ({
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "flex-end",
}));
